var _desc, _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSecond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "155px",
    height: "215px",
    viewBox: "0 0 155 215",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.1,85.7 C4.699998,73.69994 6.099984,62.5500515 9.3,52.25 C12.500016,41.9499485 17.299968,32.9500385 23.7,25.25 C30.100032,17.5499615 38.1499515,11.5500215 47.85,7.25 C57.5500485,2.9499785 68.699937,0.8 81.3,0.8 C90.900048,0.8 100.049956,2.299985 108.75,5.3 C117.450043,8.300015 125.099967,12.599972 131.7,18.2 C138.300033,23.800028 143.54998,30.699959 147.45,38.9 C151.350019,47.100041 153.3,56.299949 153.3,66.5 C153.3,77.100053 151.600017,86.199962 148.2,93.8 C144.799983,101.400038 140.300028,108.14997 134.7,114.05 C129.099972,119.950029 122.750035,125.299976 115.65,130.1 C108.549964,134.900024 101.400036,139.649977 94.2,144.35 C86.999964,149.050024 80.000034,154.099973 73.2,159.5 C66.399966,164.900027 60.400026,171.199964 55.2,178.4 L154.5,178.4 L154.5,215 L0.3,215 C0.3,202.799939 2.0499825,192.200045 5.55,183.2 C9.0500175,174.199955 13.79997,166.150036 19.8,159.05 C25.80003,151.949965 32.8499595,145.40003 40.95,139.4 C49.0500405,133.39997 57.599955,127.300031 66.6,121.1 C71.200023,117.899984 76.099974,114.650017 81.3,111.35 C86.500026,108.049984 91.2499785,104.40002 95.55,100.4 C99.8500215,96.39998 103.449985,91.900025 106.35,86.9 C109.250014,81.899975 110.7,76.200032 110.7,69.8 C110.7,59.599949 107.750029,51.6500285 101.85,45.95 C95.9499705,40.2499715 88.400046,37.4 79.2,37.4 C72.999969,37.4 67.7500215,38.8499855 63.45,41.75 C59.1499785,44.6500145 55.700013,48.4499765 53.1,53.15 C50.499987,57.8500235 48.6500055,63.0499715 47.55,68.75 C46.4499945,74.4500285 45.9,80.099972 45.9,85.7 L5.1,85.7 Z",
    id: "path-1645029657295"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: 2
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-1645029657295",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1645029657295"
  })), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("path", {
    d: "M-218,-126 L46.0029159,346.352281",
    id: "Line-2-Copy",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029657295)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-208,-126 L56.0029159,346.352281",
    id: "Line-2-Copy-2",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029657295)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-198,-126 L66.0029159,346.352281",
    id: "Line-2-Copy-3",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029657295)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-188,-126 L76.0029159,346.352281",
    id: "Line-2-Copy-4",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029657295)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-178,-126 L86.0029159,346.352281",
    id: "Line-2-Copy-5",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029657295)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-168,-126 L96.0029159,346.352281",
    id: "Line-2-Copy-6",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029657295)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-158,-126 L106.002916,346.352281",
    id: "Line-2-Copy-7",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029657295)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-148,-126 L116.002916,346.352281",
    id: "Line-2-Copy-8",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029657295)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-138,-126 L126.002916,346.352281",
    id: "Line-2-Copy-9",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029657295)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-128,-126 L136.002916,346.352281",
    id: "Line-2-Copy-10",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029657295)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-118,-126 L146.002916,346.352281",
    id: "Line-2-Copy-11",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029657295)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-108,-126 L156.002916,346.352281",
    id: "Line-2-Copy-12",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029657295)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-98,-126 L166.002916,346.352281",
    id: "Line-2-Copy-13",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029657295)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-88,-126 L176.002916,346.352281",
    id: "Line-2-Copy-14",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029657295)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-78,-126 L186.002916,346.352281",
    id: "Line-2-Copy-15",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029657295)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-68,-126 L196.002916,346.352281",
    id: "Line-2-Copy-16",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029657295)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-58,-126 L206.002916,346.352281",
    id: "Line-2-Copy-17",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029657295)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-48,-126 L216.002916,346.352281",
    id: "Line-2-Copy-18",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029657295)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-38,-126 L226.002916,346.352281",
    id: "Line-2-Copy-19",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029657295)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-28,-126 L236.002916,346.352281",
    id: "Line-2-Copy-20",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029657295)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-18,-126 L246.002916,346.352281",
    id: "Line-2-Copy-21",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029657295)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8,-126 L256.002916,346.352281",
    id: "Line-2-Copy-22",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029657295)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,-126 L266.002916,346.352281",
    id: "Line-2-Copy-23",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029657295)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,-126 L276.002916,346.352281",
    id: "Line-2-Copy-24",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029657295)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,-126 L286.002916,346.352281",
    id: "Line-2-Copy-25",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029657295)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,-126 L296.002916,346.352281",
    id: "Line-2-Copy-26",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029657295)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42,-126 L306.002916,346.352281",
    id: "Line-2-Copy-27",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029657295)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,-126 L316.002916,346.352281",
    id: "Line-2-Copy-28",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029657295)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62,-126 L326.002916,346.352281",
    id: "Line-2-Copy-29",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029657295)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72,-126 L336.002916,346.352281",
    id: "Line-2-Copy-30",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029657295)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82,-126 L346.002916,346.352281",
    id: "Line-2-Copy-31",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029657295)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92,-126 L356.002916,346.352281",
    id: "Line-2-Copy-32",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029657295)"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecond);
export default ForwardRef;